<template>
    <div id="vipPanel" class="cover vip_cover">
        <div class="cover_center_panel vip_cover_panel">
            <div class="panel_close_icon" @click="closePanel"><svg data-v-374434c9="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path data-v-374434c9="" fill="currentColor" d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"></path></svg></div>
            <div class="panel_title">给朋友一个小小的AI震撼</div>
            <div class="panel_content">
                <div class="text"> 复制下方链接，邀请新朋友使用 ， <span> 可以获得 <span class="text-orange">5</span> 次问答机会哦！ </span></div>
                <div class="copy_content"> 快看，我正在让AI为我打工😎😎😎！ <br> 自动写材料📝、快速学知识📖、解答任何问题👩&zwj;🏫，都不在话下！ <br> PC端打开效果更佳更爽👏🏻👏🏻 <br> 点击链接进入 首选AI，🌟开启属于你的AI时代！ 
                    <div class="share_link">https://chat.lanrenbangong.com/share?invite_code={{ invite_code }}</div>
                </div>
            </div>
            <div class="panel_bottom"><button @click="copytext" class="copy_btn">复制链接</button></div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        props: ['showPopup'],
        data() {
            return {
                invite_code:""
            }
        },
        created() {
            this.invite_code = localStorage.getItem("invite_code")||"";
        },
        mounted(){
        },
        methods: {
            closePanel(){
                this.$emit("update:showPopup",false);
            },
            copytext(){
                let text = "快看，我正在让AI为我打工😎😎😎！ \n自动写材料📝、快速学知识📖、解答任何问题👩&zwj;🏫，都不在话下！\nPC端打开效果更佳更爽👏🏻👏🏻  点击链接进入Talking AI，🌟开启属于你的AI时代！\n https://chat.lanrenbangong.com/share?invite_code="+this.invite_code
                const input = document.createElement('input');
                input.setAttribute('readonly', 'readonly');
                input.setAttribute('value', text);
                document.body.appendChild(input);
                input.setSelectionRange(0, 9999);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);
                this.$toast("复制成功");
            },
        },
        beforeDestroy(){
        }
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .vip_cover{
        .vip_cover_panel{
            width: 600px;
            border-radius: 3px;
            .panel_close_icon{
                position: absolute;
                top: 6px;
                right: 0;
                padding: 0;
                width: 54px;
                height: 54px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                svg{
                    width: 20px;
                    height: 20px;
                }
            }
            .panel_title{
                font-size: 20px;
                text-align: center;
                padding: 24px;
            }
            .panel_content{
                padding: 16px;
                .text {
                    font-size: 16px;
                    line-height: 48px;
                    .text-orange{
                        font-size: 20px;
                        color: rgb(255, 114, 44);
                    }
                }
                .copy_content{
                    padding: 16px;
                    border: 1px solid rgb(228, 228, 229);
                    border-radius: 8px;
                    margin-top: 16px;
                    line-height: 1.6;
                    font-size: 14px;
                    .share_link{
                        margin-top: 12px;
                        color: rgb(23, 74, 228);
                    }
                }
            }
            .panel_bottom{
                padding-bottom: 16px;
                justify-content: center;
                display: flex;
                .copy_btn{
                    padding: 10px 64px;
                    font-size: 14px;
                    color: #fff;
                    background-color: #174AE4;
                    border-radius: 3px;
                    border: none;
                    line-height: 1;
                }
            }
        }
    }
</style>